import UserDetails from "./user-details.component";

export default UserDetails;
